// extracted by css-extract-rspack-plugin
export default {"textBlock":"P5h2KZ0zPIMg6ENg","expanded":"LhCwreeuHCkCeyEX","textBlockUnsetFont":"MLVl2urMwjI0kV_G","buttonText":"cLl0EvzNuKYcM6Qi"};